import { gql } from '@apollo/client';

const PROGRAM_DETAILS = gql`
  fragment ProgramDetails on Programs {
    about
    achievements
    description
    duration
    durationMetric
    inviteOnly
    subscriptionOnly
    name
    id
    organisationId
    price
    published
    image
    programCoursesAggregate {
      agg_count
    }
    programTags {
      tag
      count
    }
  }
`;

export const GET_DISCOVER_PROGRAMS = gql`
  query GetDiscoverPrograms($userId: Int4!) {
    discoverPrograms: programs(
      where: {
        published: { _eq: "true" }
        _not: { programEnrollments: { userId: { _eq: $userId } } }
      }
    ) {
      ...ProgramDetails
    }
  }
  ${PROGRAM_DETAILS}
`;
